import React from 'react';
import {connect} from 'react-redux';
import {
	closeMeetUsPopup, closePagePicker, openPagePicker,
	updateEditMeetUsSection
} from '../../actions';
import {
	updateTitleFieldInTheSectionEditPopup,
	updateBodyFieldInTheSectionEditPopup,
	updateMeetingsBodyFieldInTheSectionEditPopup,
	updateCareersBodyFieldInTheSectionEditPopup,
	updateMeetUsEventsPage,
	updateMeetUsMeetingsPage,
	updateMeetUsCareersPage
} from '../../sections/actions';
import MeetUsSectionEditPopup from './meet_us_section_edit';
import {clearPageSearchFilter} from "../../../page-picker/actions";
import {onSearchPages} from "../../../page-picker/thunks";

class MeetUsPopup extends React.Component {

    render () {

        return (
            <MeetUsSectionEditPopup
                open={this.props.meetUsSectionEditOpen}
                siteId={this.props.siteId}
                title={this.props.meetUsSectionTitle}
                body={this.props.meetUsSectionBody}
                eventsPage={this.props.meetUsSectionEventsPage}
                meetingsPage={this.props.meetUsSectionMeetingsPage}
                meetingsBody={this.props.meetUsSectionMeetingsBody}
                careersPage={this.props.meetUsSectionCareersPage}
                careersBody={this.props.meetUsSectionCareersBody}
                sectionPagePickerPopupOpen={this.props.sectionPagePickerPopupOpen}
                pageSearchCriteria={this.props.pageSearchCriteria}
                allPagesBySearchCriteria={this.props.allPagesBySearchCriteria}
                onSearchPages={this.props.onSearchPages}
                onUpdateTitleField={
                    title => this.props.updateMeetUsSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateMeetUsSectionBodyField(body)
                }
                onUpdateMeetingsBodyField={
	                body => this.props.updateMeetUsSectionMeetingsBodyField(body)
                }
                onPickEventsPage={this.props.onPickEventsPage}
                onPickMeetingsPage={this.props.onPickMeetingsPage}
                onPickCareersPage={this.props.onPickCareersPage}
                openPagePicker={
	                () => this.props.openPagePicker()
                }
                closePagePicker={
	                () => {
		                this.props.closePagePicker();
		                this.props.clearPageSearchFilter();
	                }
                }
                onUpdateCareersBodyField={
	                body => this.props.updateMeetUsSectionCareersBodyField(body)
                }
                onHandleSubmit={() =>
                    this.props.updateMeetUsSectionContents(
                        this.props.pageId,
                        this.props.findYourProjectSectionId,
                        this.props.sectionData,
                    )
                }
                onHandleClose={
                    () => this.props.closeMeetUsSectionPopup()
                }
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    sectionData: state.pageBuilderSectionPopup.data,
    findYourProjectSectionId: state.pageBuilderSectionPopup.sectionId,
    meetUsSectionEditOpen: state.pageBuilder.meetUsSectionPopup.open,
    meetUsSectionTitle: state.pageBuilderSectionPopup.data.title,
    meetUsSectionBody: state.pageBuilderSectionPopup.data.body,
    meetUsSectionMeetingsBody: state.pageBuilderSectionPopup.data.meetings_body,
    meetUsSectionMeetingsPage: state.pageBuilderSectionPopup.data.meetings_page,
    meetUsSectionEventsPage: state.pageBuilderSectionPopup.data.events_page,
    meetUsSectionCareersBody: state.pageBuilderSectionPopup.data.careers_body,
    meetUsSectionCareersPage: state.pageBuilderSectionPopup.data.careers_page,
    meetUsSectionPageId: state.pageBuilderSectionPopup.pageId,
    sectionPagePickerPopupOpen: state.pageBuilder.sectionPagePickerPopup.open,
    clearPageSearchFilter: clearPageSearchFilter,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    siteId: state.pageBuilder.pages[props.pageId].meta.site_id,
});

export default connect(
    mapStateToProps, {
        updateMeetUsSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateMeetUsSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateMeetUsSectionMeetingsBodyField: updateMeetingsBodyFieldInTheSectionEditPopup,
        updateMeetUsSectionCareersBodyField: updateCareersBodyFieldInTheSectionEditPopup,
        updateMeetUsSectionContents: updateEditMeetUsSection,
        closeMeetUsSectionPopup: closeMeetUsPopup,

		openPagePicker: openPagePicker,
		closePagePicker: closePagePicker,
		onSearchPages: onSearchPages,
		onPickEventsPage: updateMeetUsEventsPage,
		onPickMeetingsPage: updateMeetUsMeetingsPage,
		onPickCareersPage: updateMeetUsCareersPage,
    }
)(MeetUsPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/meet_us_popup.js